<template>
    <div></div>
</template>


<script>
export default {
    created(res){
        let id = this.$route.query.id;
        let type = this.$route.query.type;
        let url = this.$route.query.url;
        this.$router.replace({
            path:url,
            query:{id:id,type:type},
        })
    }
}
</script>
